export const header = 10
export const bottombar = 10
export const bottombarOverlay = 9
export const login = 3
export const footer = 2


// WEBPACK FOOTER //
// ./src/styles/z-index.js